import React from 'react'
import Splider from './Splider'
import { useSelector } from 'react-redux';

const ProductsRequmendedCategories = () => {
    const {products_main_categories,products_categories}=useSelector((state)=>state.HomeReducer);

  return (
    <div>
         <div className='category-section'>
          {products_main_categories.map((category)=>(
            <Splider products={category.products} category={category} type="products_main_categories"/>
          ))}
        </div>
        <div className='category-section'>
          {products_categories.map((category)=>(
            <Splider products={category.products} category={category} type="products_categories"/>
          ))}
        </div>
    </div>
  )
}

export default ProductsRequmendedCategories